<template>
    <div class="history-logs">
        <div class="search-call-container">
            <!--Filter or search call history-->
            <div class="p-12" style="border-bottom: 1px solid #EFEFEF">
                <TimeRangePicker
                    ref="TimeRangePicker"
                    v-model="timeRange"
                ></TimeRangePicker>
                <div class="centerY mt-8" style="gap: 8px">
                    <div
                        v-for="item in historyTypes"
                        :key="item.value"
                        class="filter-chip"
                        :class="item.value === filters.type ? 'chip-activated' : ''"
                        @click="selectType(item)"
                    >
                        {{ item.text }}
                    </div>
                </div>
                <div style="position: relative" class="mt-8">
                    <v-text-field
                        hide-details
                        v-model="searchText"
                        :placeholder="$f.tc('searchBy.phoneNameCallId')"
                        @focusout="resetSearch"
                        @keypress.enter="resetSearch"
                        class="input-custom"
                        spellcheck="false"
                    ></v-text-field>
                    <div class="btn-icon-custom btn-search">
                        <img src="/img/search_grey.svg" @click="resetSearch" alt="icon-search">
                    </div>
                </div>
            </div>
            <!--List call history-->
            <div class="list-call fci-scrollbar" ref="LogContainer" v-on="scrollHandlers">
                <div v-if="callList.length === 0 && !loading" class="centerXY no-data">
                    <img src="/img/debug/not-found.svg" alt="icon-not-found">
                    <div class="no-data-title">
                        {{ $f.tc('noDataAvailable') }}
                    </div>
                    <div class="no-data-des">
                        {{ $f.tc('notFoundCall') }}
                    </div>
                </div>
                <div
                    v-else
                    v-for="(call, i) in callList"
                    :key="i"
                    class="call-item"
                    :class="i === activeCallIdx ? 'active' : ''"
                    @click="loadCallHistory(call, i)"

                >
                    <div class="type-call">
                        <div class="icon-chat-test" v-if="call.phone === 'test - phone'">
                            <img src="/img/debug/bot.png" alt="icon-chat-test">
                        </div>
                        <div class="icon-call" v-else>
                            <img src="/img/debug/call.png" alt="icon-call">
                        </div>
                    </div>
                    <div>
                        <div class="centerY">
                            <div class="call-item-name">{{ call.name }}</div>
                            <div class="call-item-phone">{{ call.phone }}</div>
                        </div>
                        <div class="call-item-id" @dblclick="copyCallId(call.id)"
                             :title="$f.tc('dblClickToCopy', [$t('callId')])">{{ call.id }}
                        </div>
                        <div class="call-item-time">
                            {{ $f.formatDateTime(call.created_time) }}
                        </div>

                    </div>
                </div>
                <v-layout justify-center v-if="loading" class="px-20 py-12">
                    <v-icon class="tm-spin">mdi-loading</v-icon>
                </v-layout>
            </div>
        </div>
    </div>
</template>
<script>
import TimeRangePicker from '@/modules/fptai/components/TimeRangePicker.vue'
import ScenarioService from '@/services/scenario.service'
import lodash from 'lodash'
import {mapState} from 'vuex'
import $utils from '@/utils/utils'
import $const from '@/utils/const'

const {CardType} = ScenarioService

export default {
    name: 'DebugHistoryLogs',
    components: {TimeRangePicker},
    data() {
        return {
            timeRange: 'today',
            searchText: '',
            filters: {
                type: $const.HistoryTypes.ALL
            },
            callList: [],
            loading: false,
            loadingMessage: false,
            page: 1,
            page_size: 20,
            scrollEnd: false,
            scrollHandlers: {
                scroll: e => {
                    let element = e.target
                    let maxScrollTop = element.scrollHeight - element.clientHeight
                    if (maxScrollTop - 5 <= element.scrollTop) {
                        if (this.loading || this.scrollEnd) {
                            return
                        }
                        this.page++
                        this.searchCallHistory()
                    }
                }
            },
            activeCallIdx: 0,
        }
    },
    computed: {
        ...mapState({
            callLogActivated: state => state.debug.callLogActivated,
            parentMap: state => state.scenario.parentMap,
            parentNodeSlugMap: state => state.scenario.parentNodeSlugMap,
            treeData: state => state.scenario.treeData,
            nodeList: state => state.debug.nodeList,
        }),
        historyTypes () {
            return [
                {
                    text: this.$f.tc('all'),
                    value: $const.HistoryTypes.ALL
                },
                {
                    text: this.$f.tc('callOnly'),
                    value: $const.HistoryTypes.CALL
                },
                {
                    text: this.$f.tc('chatOnly'),
                    value: $const.HistoryTypes.CHAT
                }
            ]
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.scenarioId = this.$route.params.scenarioId
            this.$nextTick(() => {
                this.$store.dispatch(this.$actionTypes.NAVIGATION, false)
                this.resetSearch()
            })
        },

        // functions for list history calls
        resetSearch() {
            this.page = 1
            this.callList = []
            this.scrollEnd = false
            return this.searchCallHistory()
        },
        searchCallHistory(timestamp = null) {
            this.loading = true
            let timeRange = timestamp ? timestamp : this.$refs.TimeRangePicker ? this.$refs.TimeRangePicker.getTimestamp() : null
            if (!timeRange) {
                return
            }

            return ScenarioService.HistoryService.search(this.$route.params.scenarioId, {
                ...timeRange,
                search: this.searchText,
                type: this.filters.type,
                page: this.page,
                page_size: this.page_size
            }).then(
                result => {
                    if (result.data.data.length > 0) {
                        let nextCallList = result.data.data.map(call => ({
                            ...call,
                            name: call.name || '---unknown---',
                            phone: call.phone || '---unknown---'
                        }))
                        this.callList = this.$lodash.uniqBy(this.callList.concat(nextCallList), item => item.id)
                    } else {
                        this.scrollEnd = true
                        if (this.page > 1) {
                            this.page--
                        }
                    }

                    if (this.callList.length > 0) {
                        this.loadCallHistory(this.callList[0], 0)
                    } else {
                        this.$store.dispatch(this.$actionTypes.debug.RESET_ACTIVATED)
                    }

                    this.loading = false
                }
            ).finally(() => {
                this.loading = false
            })
        },
        addInitAndEndNode(callHistoryLog = [], logList = []) {
            let rootNode = this.treeData.nodeList.find(i => i.id === this.treeData.startId)
            let endCall = logList.find(log => log._source.input.type === 'end_call')
            let cardLogsInit = logList[0]._source.card_logs ? logList[0]._source.card_logs.filter(i => i.node_id === this.treeData.startId) : []
            let cardLogsEnd = logList[logList.length - 1]._source.card_logs ? logList[logList.length - 1]._source.card_logs.filter(i => i.node_id === this.treeData.startId) : []
            let cardEnds = []
            let cardListEnd = []
            let cardInits = []
            let cardListInit = []
            const rootNodeCards = rootNode.config.cardList
            for (let idxCard in rootNodeCards) {
                if (rootNodeCards[idxCard]?.type !== CardType.LUA) {
                    continue
                }

                let cardInit = cardLogsInit.find(i => i.index === +idxCard)
                if (rootNodeCards[idxCard].name === 'init' && cardInit) {
                    cardInits.push(cardInit)
                    cardListInit.push(cardInit)
                }

                let cardEnd = cardLogsEnd.find(i => i.index === +idxCard)
                if (rootNodeCards[idxCard].name === 'end' && cardEnd) {
                    cardEnds.push(cardEnd)
                    cardListEnd.push(cardEnd)
                }
            }

            callHistoryLog.unshift({
                node: {type: 'DEBUG', name: 'init', card_list: rootNode.config.cardList},
                input: {},
                output: {},
                latency: cardInits.reduce((sum, i) => sum + i.latency, 0),
                cardLogs: cardInits,
                message: '',
            })
            if (endCall) {
                callHistoryLog.push({
                    node: {type: 'DEBUG', name: 'end', card_list: rootNode.config.cardList},
                    input: endCall._source.input.user_attributes,
                    output: endCall._source.user_attribute,
                    latency: cardEnds.reduce((sum, i) => sum + i.latency, 0),
                    cardLogs: cardEnds,
                    message: '',
                })
            }
        },
        loadCallHistory(call, idx) {
            if (lodash.isEqual(this.callLogActivated, call)) {
                return
            }

            this.activeCallIdx = idx
            this.$store.commit(this.$actionTypes.debug.CALL_LOG_ACTIVATED, call)

            if ($utils.isUUID(call.id)) {
                // load FS log
                ScenarioService.getFSLog(call.id).then((res) => {
                    this.$store.commit(this.$actionTypes.debug.FS_LOG, res.data)
                })
                ScenarioService.getCallMonitor(call.id).then((res) => {
                    this.$store.commit(this.$actionTypes.debug.CALL_MONITOR, res.data._source)
                })
            } else {
                this.$store.commit(this.$actionTypes.debug.FS_LOG, null)
                this.$store.commit(this.$actionTypes.debug.CALL_MONITOR, null)
            }

            // load messages
            ScenarioService.HistoryService.read(this.$route.params.scenarioId, call.id).then(
                result => {
                    let logList = lodash.orderBy(result.data, '_source.created_time', 'asc')
                    let logs = logList.filter(log => log._source.input.type !== 'end_call')

                    // update list monitoring variables
                    this.updateMonitoringVars(logs)

                    // update detail flow nodes
                    let callHistoryLog = []
                    let checkHasWelcome = false
                    let idxLog = 0
                    for (let log of logs) {
                        let nodesFlow = log._source.nodes_flow
                        if (!nodesFlow) {
                            this.$store.dispatch(this.$actionTypes.debug.NOTICE_DATA_FLOW_ERROR)
                            this.$appService.toastWarning(this.$f.tc('debugModeNotSupportForCall'))
                            return
                        }


                        const middleNode = nodesFlow.middle_node
                        const toNode = nodesFlow.to_node
                        const detailInput = log['_source'].input

                        // check invalid data and validate toNode
                        if (!nodesFlow || !toNode || Array.isArray(toNode)) {
                            callHistoryLog = []
                            this.$appService.toastError(`${this.$f.tc('debugMode')} ${this.$t('notSupportFlowData')}!`)
                            break
                        }

                        // check multi welcome node
                        if (log._source.input.type === 'payload' && log._source.input.message.content === 'welcome') {
                            if (checkHasWelcome) {
                                callHistoryLog = []
                            } else {
                                checkHasWelcome = true
                            }
                        }

                        if (middleNode) {
                            if (middleNode.node?.card_list) {
                                middleNode.node.card_list = middleNode.node.card_list.filter(i => i.name !== 'init' && i.name !== 'end')
                            }

                            const cardLogsMiddleNode = logs[idxLog]?._source.card_logs || []
                            let middleNodeItem = {
                                node: middleNode,
                                latency: log._source.latency,
                                cardLogs: cardLogsMiddleNode.filter(i => i.node_id === middleNode.id),
                                nlpResponse: log._source.nlp_response,
                            }
                            if (detailInput.type === 'text') {
                                middleNodeItem.message = detailInput.message.content
                            }

                            callHistoryLog.push(middleNodeItem)
                        }

                        if (toNode?.node?.card_list) {
                            toNode.node.card_list = toNode.node.card_list.filter(i => i.name !== 'init' && i.name !== 'end')
                        }

                        const cardLogsToNode = logs[idxLog + 1]?._source.card_logs || []
                        const outputLog = Array.isArray(log['_source'].output) ? log['_source'].output[0] : log['_source'].output
                        const toNodeHistory = {
                            node: toNode,
                            input: log._source.input.user_attributes,
                            output: log._source.user_attribute,
                            latency: log._source.latency,
                            cardLogs: cardLogsToNode.filter(i => i.node_id === toNode.id),
                            transferCallNumber: log._source.output.next_action?.type === 'transfer_call' ?
                                logList[idxLog + 1]._source.input.user_attributes?.$transfer_call_number || '' : '',
                            message: outputLog.prompt,
                        }

                        // check use audio
                        if (outputLog.audio_slug) {
                            toNodeHistory.audio = {
                                slug: outputLog.audio_slug,
                                link: outputLog.audio_link,
                                name: outputLog.audio_name,
                            }
                        }

                        callHistoryLog.push(toNodeHistory)
                        idxLog += 1
                    }
                    this.addInitAndEndNode(callHistoryLog, logList)

                    // update success nodes
                    callHistoryLog.forEach((i, idx) => i.index = idx)
                    this.$store.dispatch(this.$actionTypes.debug.UPDATE_DATA_FLOW, {
                        nodeList: callHistoryLog,
                        startId: this.treeData.startId,
                        startSlug: this.treeData.startSlug
                    })
                }
            )
        },
        updateMonitoringVars(logList) {
            // validate log list
            if (!logList || logList.length === 0) {
                return
            }

            let monitoringVars = []
            let keyList = []

            for (let log of logList) {
                let output = log._source.user_attribute
                keyList = output ? keyList.concat(Object.keys(output)) : []
            }

            keyList.forEach(key => {
                if (!monitoringVars.includes(key)) {
                    monitoringVars.push(key)
                }
            })

            this.$store.commit(this.$actionTypes.debug.VARIABLES, monitoringVars)
        },
        copyCallId(callId) {
            this.$utils.copyToClipboard(callId, this.$f.tc('copyCallId'))
        },
        selectType (item) {
            this.filters.type = item.value
            this.resetSearch()
        },
    },
    watch: {
        timeRange: 'resetSearch',
    }
}
</script>

<style scoped lang="scss">
.history-logs {
    position: relative;
    height: calc(100vh - 127px);
    border-right: 1px solid #EFEFEF;
    box-shadow: rgba(149, 157, 165, 0.2) 1.95px 8px 18px;
    z-index: 1;

    .search-call-container {
        width: 450px;
        background: #FFFFFF;
    }

    .btn-toggle-search {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: -22px;
        width: 22px;
        height: 80px;
        background: #FFFFFF;
        border-radius: 0 10px 10px 0;
        //box-shadow: rgba(0, 0, 0, 0.05) 8px 0 8px 0;
        box-shadow: 6px 0 8px 4px rgba(0, 0, 0, 0.05);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
            width: 16px;
        }
    }

    .btn-search {
        position: absolute;
        top: 4px;
        right: 5px;
        width: 24px !important;
        height: 24px !important;

        img {
            transform: scale(0.7);
        }
    }

    .no-data {
        flex-direction: column;
        margin-top: 64px;

        img {
            width: 40%;
        }

        .no-data-title {
            margin-top: -12px;
            font-family: "open sans semi", serif;
            font-size: 16px;
            color: #545253;
        }

        .no-data-des {
            color: #9A9A9A;
            font-size: 13px;
        }
    }
}

.search-call-container {
    .input-custom ::v-deep {
        .v-input__slot {
            padding: 6px 30px 6px 12px !important;
        }
    }

    .list-call {
        height: calc(100vh - 267px);
        overflow-y: auto;
        padding: 12px;
    }
}

.list-call {
    .call-item {
        display: flex;
        margin: 8px 0;
        padding: 12px;
        background: #FFF;
        box-shadow: rgba(0, 0, 0, 0.05) 0 6px 24px 0;
        border: 2px solid #EFEFEF;
        border-radius: 5px;
        font-family: "open sans", serif !important;
        font-size: 14px !important;
        cursor: pointer;

        &:first-child {
            margin-top: 0;
        }

        &:last-child {
            margin-bottom: 0;
        }

        &.active {
            border-color: #0052CC !important;
            background: #EAEEFF;
            color: #0052CC !important;
        }

        &:hover {
            border-color: #0052CC !important;
            color: #0052CC;
            transition: 0.3s;
        }

        .type-call {
            width: 45px;
            margin-right: 8px;

            div {
                border-radius: 10px;
                width: 45px;
                height: 45px;
                padding: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: 2px solid #FFFFFF;
            }

            .icon-call {
                background: #7cc250;
            }

            .icon-chat-test {
                background: #e8edfc;
            }

            img {
                width: 100%;
            }
        }

        .call-item-name {
            font-family: "open sans semi", serif;
            font-size: 15px;
        }

        .call-item-phone {
            margin-left: 6px;
            background: #E6E6E6;
            border-radius: 10px;
            font-family: "open sans semi", serif;
            font-size: 12px;
            padding: 2px 8px;
        }

        .call-item-id {
            font-size: 13px;
            font-family: "open sans", serif;
            margin-top: 3px;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 340px;
            white-space: nowrap;
        }

        .call-item-time {
            font-size: 13px;
            font-family: "open sans", serif;
            margin-top: 6px;
            color: #9A9A9A;
        }
    }
}

.filter-chip {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    border: 1px solid #DBDBDB;
    border-radius: 5px;
    cursor: pointer;
    flex: 1;
    color: #818181;
    font-size: 14px;

    &:nth-child(2), &:nth-child(3) {
        flex: 2;
    }
}

.chip-activated {
    background: #0052CC;
    color: #FFF;
    border-color: #0052CC;
}
</style>
